import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex" }

import FilterIcon from './FilterIcon.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'PillValueIcons',
  props: {
    type: {},
    iconName: {},
    icons: {},
    displayMultipleFilterIcons: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.icons, (icon, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(["filter-value-icon", {
        'rounded-none z-auto h-4 w-4 items-center -ml-[7px] first:ml-0': _ctx.type === 'tags',
      }])
      }, [
        (_ctx.displayMultipleFilterIcons)
          ? (_openBlock(), _createBlock(FilterIcon, {
              key: 0,
              icon: icon.src || icon,
              "icon-name": icon.src || _ctx.iconName,
              type: _ctx.type,
              "icon-type": icon.type,
              color: icon.color || ''
            }, null, 8, ["icon", "icon-name", "type", "icon-type", "color"]))
          : _createCommentVNode("", true)
      ], 2))
    }), 128))
  ]))
}
}

})